import LaporanPenerimaanBarang from "./LaporanPenerimaanBarang"

export default LaporanPenerimaanBarang
